import { ReactNode } from 'react'
import { Col, Form, Row } from 'react-bootstrap'

type FormRowProps = {
    label: string
    labelWidth?: number
    fieldWidth?: number
    buttonWidth?: number
    children: ReactNode
    button?: ReactNode
    className?: string
}

export const FormRow = ({
    label,
    labelWidth = 3,
    fieldWidth = 6,
    buttonWidth = 3,
    children,
    button,
    className = '',
}: FormRowProps) => (
    <Form.Group as={Row} className={className} style={{ flexWrap: 'nowrap' }}>
        <Form.Label column xs={labelWidth}>
            {label}
        </Form.Label>
        <Col xs={fieldWidth}>{children}</Col>
        <Col xs={buttonWidth}>{button ?? null}</Col>
    </Form.Group>
)
